"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompareProducts = void 0;
var React = require("react");
var ProductInfo_1 = require("./ProductInfo");
var Nutrients_1 = require("./Nutrients");
var Allergens_1 = require("./Allergens");
var Ingredients_1 = require("./Ingredients");
var Markings_1 = require("./Markings");
var Store_1 = require("../compare/Store");
var Beverage_1 = require("./Beverage");
var CompareProducts = function (props) {
    return React.createElement(Store_1.StoreProvider, { state: props },
        React.createElement("div", { className: "compare-page" },
            React.createElement("div", { className: "row" },
                React.createElement("h1", { className: "main-header" }, "Sammenlign produkter")),
            React.createElement(ProductInfo_1.ProductInfo, null),
            React.createElement(Beverage_1.Beverage, null),
            React.createElement(Ingredients_1.Ingredients, null),
            React.createElement(Nutrients_1.Nutrients, null),
            React.createElement(Allergens_1.Allergens, null),
            React.createElement(Markings_1.Markings, null)));
};
exports.CompareProducts = CompareProducts;
